import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  tables: {}, // { [tableKey]: { [cacheKey]: { data, totalCount, lastFetched, stale } } }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
